module.exports = __webpack_public_path__ + "media/images/front/img_movie_feature03-7cbc7bea951c4df749a5b45838c92f6f.jpg";